import React from 'react';

interface ResultCardContextType {
  ratingTooltipText: string;
  listingResultTracking: {
    clickedSingle: () => void;
    clickedLogo: () => void;
    clickedTitle: () => void;
    clickedLearnMore: () => void;
    clickedProgramLink: () => void;
    clickedSeeAllPrograms: () => void;
    viewedAllPrograms: () => void;
    viewedHighlights: () => void;
    viewedResult: (
      wasOnScreenOnLoad: boolean | null,
      wasWithinViewPortOnLoad: boolean | null
    ) => void;
  };
  index: number;
  schoolName: string;
  isOffsiteConversion: boolean;
}

const resultCardContext: ResultCardContextType = {
  ratingTooltipText: '',
  listingResultTracking: {
    clickedSingle: () => {},
    clickedLogo: () => {},
    clickedTitle: () => {},
    clickedLearnMore: () => {},
    clickedProgramLink: () => {},
    clickedSeeAllPrograms: () => {},
    viewedAllPrograms: () => {},
    viewedHighlights: () => {},
    viewedResult: () => {},
  },
  index: 0,
  schoolName: '',
  isOffsiteConversion: false,
};

const ResultCardContext = React.createContext(resultCardContext);

export default ResultCardContext;
